import { P } from "../../../../AbstractElements";
import { useState } from "react";
import { SELLIND_PRODUCT_COLUMN } from "../../../../Data/Dashboard";
import { SellingProductActions } from "./SellingProductActions";
import { SellingProductDetails } from "./SellingProductDetails";
import { SellingProductCheckbox } from "./SellingProductCheckbox";

export const SellingProductTabbleBody = () => {
  const [data, setData] = useState(SELLIND_PRODUCT_COLUMN);

  const deletHandler = (id: number) => {
    setData(data.filter((item) => item.id !== id));
  };

  return (
    <tbody>
      {data.map((item, index) => (
        <tr key={index}>
          <SellingProductCheckbox id={item.id} />
          <td>
            <P>{item.uid}</P>
          </td>
          <SellingProductDetails imageSrc={item.imageSrc} productName={item.productName} />
          <td>{item.category}</td>
          <td>{item.brand}</td>
          <td>{item.price}</td>
          <td>{item.stock}</td>
          <td>
            <P>
              <i className="fa fa-star font-warning"></i>
              {item.rating} ({item.ratingCount})
            </P>
          </td>
          <td>{item.order}</td>
          <td>{item.sales}</td>
          <SellingProductActions deletHandler={deletHandler} id={item.id} />
        </tr>
      ))}
    </tbody>
  );
};
